import logger from '../common/logger';

const module = 'PixelConfigurationURLClient';



const PixelConfigurationURLClient = {
  getPixelConfigFromUrl: () => {
    try {
      const arrayDelimiter = '~';
      const kvDelimeter = '.';
      const qspName = 'gupix';
      const gupix = window?.gu_qs[qspName];
      if (gupix) {
        var pixels = window.gu_qs[qspName].split(arrayDelimiter);
        var gu_additional_pixels = {};
        for (var i = 0; i < pixels.length; i++) {
          var parsed = pixels[i].split(kvDelimeter);
          gu_additional_pixels[parsed[0]] = parsed[1];
        }
        return PixelConfigurationURLClient.transformGuPixToPixelConfig(gu_additional_pixels);
      } else {
        return null;
      }
    } catch (e) {
      logger.error('Failed parsing gu pix', e, { module });
      return null;
    }
  },
  transformGuPixToPixelConfig: (guPixels) => {
    let pixelConfig = {
      facebook: {
        pixelId: guPixels?.fb,
        value: guPixels?.fbv,
        fblp: guPixels?.fblp,
        fbpp: guPixels?.fbpp,
        fbsp: guPixels?.fbsp,
        fbatc: guPixels?.fbatc,
        fbic: guPixels?.fbic,
        fbsi: guPixels?.fbsi
      },
      tiktok: {
        pixelId: guPixels?.tt,
      },
      snapchat: {
        pixelId: guPixels?.sc
      },
      google: {
        awId: guPixels?.gad,
        conversionId: guPixels?.gadc,
        value: guPixels?.gadv
      }
    };
    return pixelConfig;
  }
};
export default PixelConfigurationURLClient;